import {CardIconType, CardId, CountryCode, DateString, NonEmptyString} from '@raison/types';
import {TypeOf, null as ioNull, string as ioString, literal, type, union} from 'io-ts';

export const Card = type({
    id: CardId,
    expired_at: DateString,
    holder: NonEmptyString,
    status: union([literal('not_verified'), literal('pending'), literal('verified'), literal('fraud')]),
    number: NonEmptyString,
    type: CardIconType,
    title: NonEmptyString,
    verify_reason: union([NonEmptyString, ioNull]),
    number_split: NonEmptyString,
    last4: NonEmptyString,
    bank_name: ioString,
    bank_country: CountryCode,
});
export type Card = TypeOf<typeof Card>;
